/** Browsing is URL-scoped and never writes the student's academic profile. */
export const STUDY_YEARS = [6, 7, 8, 9, 10, 11, 12] as const;

export function resolveStudyToolYear(value: string | null, profileYear?: number | null): (typeof STUDY_YEARS)[number] | null {
  if (value === 'all') return null;
  const explicit = Number(value);
  const selected = value === null ? undefined : STUDY_YEARS.find(year => year === explicit);
  return selected ?? STUDY_YEARS.find(year => year === profileYear) ?? null;
}
